// extracted by mini-css-extract-plugin
module.exports = {"card":"CashOut_card__3j_Tr","heading":"CashOut_heading__1pRDl","grid":"CashOut_grid__3SJu7"};